import { Features } from './featureGating';

export default {
    Basic: [
        Features.OVERVIEW,
        Features.DONATIONS,
        Features.DONORS,
        Features.EVENTS,
        Features.FUNDRAISING_TOOLS,
        Features.FUNDRAISING_TOOLS_ONLINE_GIVING,
        Features.FUNDRAISING_TOOLS_SM_GIVING,
        Features.FUNDRAISING_TOOLS_SNAP_GIVE,
        Features.FUNDRAISING_TOOLS_GIVELITHON,
        Features.SOCIAL_MEDIA_FACEBOOK,
        Features.SOCIAL_MEDIA_TWITTER,
        Features.SOCIAL_MEDIA_INSTAGRAM,
        Features.SOCIAL_MEDIA_YOUTUBE,
        Features.SOCIAL_MEDIA_SNAPCHAT,
        Features.SOCIAL_MEDIA_TIKTOK,
        Features.SOCIAL_MEDIA_LINKEDIN,
        Features.INTEGRATIONS,
        Features.INTEGRATION_ACS_REALM,
        Features.INTEGRATION_F1,
        Features.INTEGRATION_F1_GO,
        Features.STUDIO_ENABLE_ROCK_INTEGRATION,
        Features.INTEGRATION_CCB,
        Features.INTEGRATION_SCHEDULING,
        Features.INTEGRATION_PC,
        Features.REPORTS,
        Features.REPORTS_BANK_DEPOSITS,
        Features.REPORTS_DONATIONS,
        Features.REPORTS_DONORS,
        Features.REPORTS_DISBURSEMENTS,
        Features.REPORTS_IMPORT_FRIENDLY,
        Features.REPORTS_QUICKBOOKS_DONOR,
        Features.REPORTS_QUICKBOOKS_ENVELOPE,
        Features.LEGACY_REPORTS_DASHBOARD,
        Features.SETTINGS_ALL,
        Features.SETTINGS_APP_PROFILE,
        Features.SETTINGS_MISSION,
        Features.SETTINGS_ORGANIZATION_INFO,
        Features.SETTINGS_ENVELOPES,
        Features.SETTINGS_USERS,
        Features.SETTINGS_CAMPUSES,
        Features.SETTINGS_QUICK_GIVE,
        Features.SETTINGS_NEED_HELP,
        Features.ONBOARDING,
        Features.SHOW_YODLEE,
        Features.ENVELOPES_PUBLIC_DETAIL,
        Features.OVERVIEW_VIDEO_CARDS,
        Features.NEW_ONBOARDING,
        Features.OVERVIEW_QUICK_POLL,
        Features.OVERVIEW_HIDE_OLD_DASHBOARD_LINK,
        Features.CAPTIVE_PORTAL,
        Features.TIMEZONES,
        Features.PRIMARY_REP_ESCALATED_NOTIFICATION,
        Features.PRIMARY_REP_SEVERE_NOTIFICATION,
        Features.PRIMARY_REP_JAN_1ST_NOTIFICATION,
        Features.STUDIO_ENABLE_REAL_TIME_UPDATES,
        Features.STUDIO_DISPLAY_NEW_LOGIN,
        Features.STUDIO_DISPLAY_NEW_LOGIN_V2,
        Features.FUNDRAISING_TOOLS_DONOR_RECOGNITION,
        Features.STUDIO_IMAGE_UPLOAD_V2,
        Features.STUDIO_APP_PROFILE_V2,
        Features.STUDIO_CUSTOMIZE_PROFILE_FIRST,
    ],
    Financial: [
        Features.OVERVIEW,
        Features.DONATIONS,
        Features.DONORS,
        Features.EVENTS,
        Features.FUNDRAISING_TOOLS,
        Features.FUNDRAISING_TOOLS_ONLINE_GIVING,
        Features.FUNDRAISING_TOOLS_SM_GIVING,
        Features.FUNDRAISING_TOOLS_SNAP_GIVE,
        Features.FUNDRAISING_TOOLS_GIVELITHON,
        Features.SOCIAL_MEDIA_FACEBOOK,
        Features.SOCIAL_MEDIA_TWITTER,
        Features.SOCIAL_MEDIA_INSTAGRAM,
        Features.SOCIAL_MEDIA_YOUTUBE,
        Features.SOCIAL_MEDIA_SNAPCHAT,
        Features.SOCIAL_MEDIA_TIKTOK,
        Features.SOCIAL_MEDIA_LINKEDIN,
        Features.INTEGRATIONS,
        Features.INTEGRATION_ACS_REALM,
        Features.INTEGRATION_F1,
        Features.INTEGRATION_F1_GO,
        Features.STUDIO_ENABLE_ROCK_INTEGRATION,
        Features.INTEGRATION_CCB,
        Features.INTEGRATION_SCHEDULING,
        Features.INTEGRATION_PC,
        Features.REPORTS,
        Features.REPORTS_BANK_DEPOSITS,
        Features.REPORTS_DONATIONS,
        Features.REPORTS_DONORS,
        Features.REPORTS_DISBURSEMENTS,
        Features.REPORTS_IMPORT_FRIENDLY,
        Features.REPORTS_QUICKBOOKS_DONOR,
        Features.REPORTS_QUICKBOOKS_ENVELOPE,
        Features.LEGACY_REPORTS_DASHBOARD,
        Features.SETTINGS_ALL,
        Features.SETTINGS_APP_PROFILE,
        Features.SETTINGS_MISSION,
        Features.SETTINGS_ORGANIZATION_INFO,
        Features.SETTINGS_ENVELOPES,
        Features.SETTINGS_USERS,
        Features.SETTINGS_CAMPUSES,
        Features.SETTINGS_QUICK_GIVE,
        Features.SETTINGS_NEED_HELP,
        Features.ONBOARDING,
        Features.SHOW_YODLEE,
        Features.ENVELOPES_PUBLIC_DETAIL,
        Features.OVERVIEW_VIDEO_CARDS,
        Features.NEW_ONBOARDING,
        Features.OVERVIEW_QUICK_POLL,
        Features.OVERVIEW_HIDE_OLD_DASHBOARD_LINK,
        Features.CAPTIVE_PORTAL,
        Features.TIMEZONES,
        Features.GIVING_TUESDAY_2023,
        Features.PRIMARY_REP_ESCALATED_NOTIFICATION,
        Features.PRIMARY_REP_SEVERE_NOTIFICATION,
        Features.PRIMARY_REP_JAN_1ST_NOTIFICATION,
        Features.STUDIO_ENABLE_REAL_TIME_UPDATES,
        Features.SCHEDULE_CALL_WITH_ONBOARDING_SUPPORT,
        Features.STUDIO_DISPLAY_NEW_LOGIN,
        Features.STUDIO_DISPLAY_NEW_LOGIN_V2,
        Features.STUDIO_ENABLE_POINTS_REWARDS_PROGRAM,
        Features.STUDIO_ENABLE_POINTS_REWARDS_PROGRAM_VIDEOS,
        Features.FUNDRAISING_TOOLS_DONOR_RECOGNITION,
        Features.STUDIO_IMAGE_UPLOAD_V2,
        Features.STUDIO_APP_PROFILE_V2,
        Features.STUDIO_CUSTOMIZE_PROFILE_FIRST,
    ],
    Admin: [
        Features.OVERVIEW,
        Features.DONATIONS,
        Features.DONORS,
        Features.EVENTS,
        Features.FUNDRAISING_TOOLS,
        Features.FUNDRAISING_TOOLS_ONLINE_GIVING,
        Features.FUNDRAISING_TOOLS_SM_GIVING,
        Features.FUNDRAISING_TOOLS_SNAP_GIVE,
        Features.FUNDRAISING_TOOLS_GIVELITHON,
        Features.SOCIAL_MEDIA_FACEBOOK,
        Features.SOCIAL_MEDIA_TWITTER,
        Features.SOCIAL_MEDIA_INSTAGRAM,
        Features.SOCIAL_MEDIA_YOUTUBE,
        Features.SOCIAL_MEDIA_SNAPCHAT,
        Features.SOCIAL_MEDIA_TIKTOK,
        Features.SOCIAL_MEDIA_LINKEDIN,
        Features.INTEGRATIONS,
        Features.INTEGRATION_ACS_REALM,
        Features.INTEGRATION_F1,
        Features.INTEGRATION_F1_GO,
        Features.STUDIO_ENABLE_ROCK_INTEGRATION,
        Features.INTEGRATION_CCB,
        Features.INTEGRATION_SCHEDULING,
        Features.INTEGRATION_PC,
        Features.REPORTS,
        Features.REPORTS_BANK_DEPOSITS,
        Features.REPORTS_DONATIONS,
        Features.REPORTS_DONORS,
        Features.REPORTS_DISBURSEMENTS,
        Features.REPORTS_IMPORT_FRIENDLY,
        Features.REPORTS_QUICKBOOKS_DONOR,
        Features.REPORTS_QUICKBOOKS_ENVELOPE,
        Features.LEGACY_REPORTS_DASHBOARD,
        Features.SETTINGS_ALL,
        Features.SETTINGS_APP_PROFILE,
        Features.SETTINGS_ORGANIZATION_INFO,
        Features.SETTINGS_BANK_INFO,
        Features.SETTINGS_USERS,
        Features.SETTINGS_ENVELOPES,
        Features.SETTINGS_CAMPUSES,
        Features.SETTINGS_MISSION,
        Features.SETTINGS_QUICK_GIVE,
        Features.SETTINGS_NEED_HELP,
        Features.ONBOARDING,
        Features.SHOW_YODLEE,
        Features.ENVELOPES_PUBLIC_DETAIL,
        Features.OVERVIEW_VIDEO_CARDS,
        Features.NEW_ONBOARDING,
        Features.OVERVIEW_QUICK_POLL,
        Features.OVERVIEW_HIDE_OLD_DASHBOARD_LINK,
        Features.CAPTIVE_PORTAL,
        Features.TIMEZONES,
        Features.GIVING_TUESDAY_2023,
        Features.ONBOARDING_INVITE_OFFICIAL,
        Features.SCHEDULE_CALL_WITH_SUPPORT,
        Features.PRIMARY_REP_ESCALATED_NOTIFICATION,
        Features.PRIMARY_REP_SEVERE_NOTIFICATION,
        Features.PRIMARY_REP_JAN_1ST_NOTIFICATION,
        Features.STUDIO_ENABLE_REAL_TIME_UPDATES,
        Features.SCHEDULE_CALL_WITH_ONBOARDING_SUPPORT,
        Features.STUDIO_REMOVE_LOG_IN_TO_OLD_DASHBOARD_LINK,
        Features.STUDIO_HIDE_DCF_WARNING_BANNERS,
        Features.STUDIO_DISPLAY_NEW_LOGIN,
        Features.STUDIO_DISPLAY_NEW_LOGIN_V2,
        Features.STUDIO_ENABLE_POINTS_REWARDS_PROGRAM,
        Features.STUDIO_ENABLE_POINTS_REWARDS_PROGRAM_VIDEOS,
        Features.FUNDRAISING_TOOLS_DONOR_RECOGNITION,
        Features.STUDIO_IMAGE_UPLOAD_V2,
        Features.STUDIO_APP_PROFILE_V2,
        Features.STUDIO_CUSTOMIZE_PROFILE_FIRST,
    ],
    'Admin Panel User': [
        Features.OVERVIEW,
        Features.DONATIONS,
        Features.DONORS,
        Features.EVENTS,
        Features.FUNDRAISING_TOOLS,
        Features.FUNDRAISING_TOOLS_ONLINE_GIVING,
        Features.FUNDRAISING_TOOLS_SM_GIVING,
        Features.FUNDRAISING_TOOLS_SNAP_GIVE,
        Features.FUNDRAISING_TOOLS_GIVELITHON,
        Features.SOCIAL_MEDIA_FACEBOOK,
        Features.SOCIAL_MEDIA_TWITTER,
        Features.SOCIAL_MEDIA_INSTAGRAM,
        Features.SOCIAL_MEDIA_YOUTUBE,
        Features.SOCIAL_MEDIA_SNAPCHAT,
        Features.SOCIAL_MEDIA_TIKTOK,
        Features.SOCIAL_MEDIA_LINKEDIN,
        Features.INTEGRATIONS,
        Features.INTEGRATION_ACS_REALM,
        Features.INTEGRATION_F1,
        Features.INTEGRATION_F1_GO,
        Features.STUDIO_ENABLE_ROCK_INTEGRATION,
        Features.INTEGRATION_CCB,
        Features.INTEGRATION_SCHEDULING,
        Features.INTEGRATION_PC,
        Features.REPORTS,
        Features.REPORTS_BANK_DEPOSITS,
        Features.REPORTS_DONATIONS,
        Features.REPORTS_DONORS,
        Features.REPORTS_DISBURSEMENTS,
        Features.REPORTS_IMPORT_FRIENDLY,
        Features.REPORTS_QUICKBOOKS_DONOR,
        Features.REPORTS_QUICKBOOKS_ENVELOPE,
        Features.LEGACY_REPORTS_DASHBOARD,
        Features.SETTINGS_ALL,
        Features.SETTINGS_APP_PROFILE,
        Features.SETTINGS_MISSION,
        Features.SETTINGS_ORGANIZATION_INFO,
        Features.SETTINGS_ENVELOPES,
        Features.SETTINGS_USERS,
        Features.SETTINGS_CAMPUSES,
        Features.SETTINGS_QUICK_GIVE,
        Features.SETTINGS_NEED_HELP,
        Features.ONBOARDING,
        Features.SHOW_YODLEE,
        Features.ENVELOPES_PUBLIC_DETAIL,
        Features.OVERVIEW_VIDEO_CARDS,
        Features.NEW_ONBOARDING,
        Features.OVERVIEW_HIDE_OLD_DASHBOARD_LINK,
        Features.CAPTIVE_PORTAL,
        Features.TIMEZONES,
        Features.ONBOARDING_INVITE_OFFICIAL,
        Features.SCHEDULE_CALL_WITH_SUPPORT,
        Features.PRIMARY_REP_ESCALATED_NOTIFICATION,
        Features.PRIMARY_REP_SEVERE_NOTIFICATION,
        Features.PRIMARY_REP_JAN_1ST_NOTIFICATION,
        Features.STUDIO_ENABLE_REAL_TIME_UPDATES,
        Features.SCHEDULE_CALL_WITH_ONBOARDING_SUPPORT,
        Features.STUDIO_REMOVE_LOG_IN_TO_OLD_DASHBOARD_LINK,
        Features.STUDIO_HIDE_DCF_WARNING_BANNERS,
        Features.STUDIO_DISPLAY_NEW_LOGIN,
        Features.STUDIO_DISPLAY_NEW_LOGIN_V2,
        Features.STUDIO_ENABLE_POINTS_REWARDS_PROGRAM,
        Features.STUDIO_ENABLE_POINTS_REWARDS_PROGRAM_VIDEOS,
        Features.FUNDRAISING_TOOLS_DONOR_RECOGNITION,
        Features.STUDIO_IMAGE_UPLOAD_V2,
        Features.STUDIO_APP_PROFILE_V2,
        Features.STUDIO_CUSTOMIZE_PROFILE_FIRST,
    ],
};
